import { StyleSheet } from '@react-pdf/renderer';

const COLORS = {
    ink: '#1a1a1a',
    inkMid: '#4b5563',
    inkMuted: '#6b7280',
    inkLight: '#9ca3af',
    rule: '#e5e7eb',
    bgSection: '#f3f4f6'
} as const;

export const tiptapPdfStyles = StyleSheet.create({
    paragraph: {
        fontSize: 11,
        lineHeight: 1.6,
        marginBottom: 6,
        color: COLORS.ink
    },
    heading1: {
        fontSize: 13,
        fontWeight: 700,
        color: COLORS.ink,
        marginTop: 6,
        marginBottom: 4
    },
    heading2: {
        fontSize: 12,
        fontWeight: 700,
        color: COLORS.ink,
        marginTop: 6,
        marginBottom: 3
    },
    heading3: {
        fontSize: 11,
        fontWeight: 700,
        color: COLORS.inkMid,
        marginTop: 5,
        marginBottom: 3
    },
    blockquote: {
        marginTop: 4,
        marginBottom: 6,
        paddingLeft: 12,
        borderLeftWidth: 3,
        borderLeftColor: COLORS.rule,
        color: COLORS.inkMid,
        fontStyle: 'italic'
    },
    hr: {
        borderBottomWidth: 1,
        borderBottomColor: COLORS.rule,
        marginVertical: 8
    },
    listItem: {
        flexDirection: 'row',
        marginTop: 1,
        marginBottom: 3
    },
    listBullet: {
        width: 11,
        fontSize: 11,
        color: COLORS.inkMid
    },
    listBody: {
        flex: 1
    },

    bold: { fontWeight: 700 },
    italic: { fontStyle: 'italic' },
    code: { fontFamily: 'Courier', backgroundColor: COLORS.bgSection, paddingHorizontal: 2 },
    link: { color: '#3773A8', textDecoration: 'underline' },
    strike: { textDecoration: 'line-through' },

    imageWrap: {
        marginTop: 8,
        marginBottom: 8,
        alignItems: 'center'
    },
    image: {
        maxWidth: '100%',
        objectFit: 'contain'
    },
    imageCaption: {
        marginTop: 3,
        fontSize: 7,
        color: COLORS.inkLight,
        fontStyle: 'italic'
    },
    // Label above the photo, flush with its left edge (photos in captioned cells
    // are pinned left so the two edges line up). Never overlaid on the image.
    imageCaptionLabel: {
        marginBottom: 2,
        fontSize: 9,
        color: COLORS.inkMid
    }
});

export { COLORS };
